module.exports = __webpack_public_path__ + "img/work2.da28cb0e.png";